import styled from "styled-components";

/**
 * Wrapper do Item de Sugestão
 * Configura o layout geral do item, incluindo transições suaves no hover.
 */
export const SuggestionItemWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: ${({ theme }) => `${theme.spacing(0.5)} ${theme.spacing(1.5)}`};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  color: ${({ theme }) => theme.colors.darkGray};
  background-color: ${({ theme }) => theme.colors.white};
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;

  &:hover {
    background-color: ${({ theme }) => theme.colors.lightBlue};
  }
`;

/**
 * Ícone Regional
 * Exibido para itens destacados, posicionado à esquerda do texto.
 */
export const RegionalIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: ${({ theme }) => theme.spacing(0.5)};

  & > svg {
    color: ${({ theme }) => theme.colors.vividBlue} !important;
    font-size: ${({ theme }) => theme.fontSizes.md};
  }
`;
